import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Check from '../common/checkbox';
import { connect } from 'react-redux';
import store from '../../store';
import { getEditPolicyOptions, getSearchResults, getSeatChartResults } from '../../actions/editPolicy-actions';
import { fetchGet, fetchPost } from '../../common/common';

import Search from '../search/Search';
import Seatchart from '../seatchart/Seatchart';
import PickUp from '../pickUp/PickUp';
import DropOff from '../dropOff/DropOff';
import PassDetails from '../passDetails/PassDetails';
import ComDetails from '../comDetails/ComDetails';
import EditSuccess from '../editSuccess/EditSuccess';

class EditDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editPrePostBooking: 'off',
            editSeatNo: 'off',
            editPickUp: 'off',
            editDropOff: 'off',
            editPassDetails: 'off',
            editComDetails: 'off',
            search: false,
            seatChart: false,
            pickUp: false,
            dropOff: false,
            passDetails: false,
            comDetails: false,
            validateOTP: true,
            editSuccess: false,
            selSeats: []
        };
    }

    componentDidMount() {
        let editPolicyDetails = this.props.editPolicy;
        let APIGetBookingDetailsResult = editPolicyDetails.data.APIGetBookingDetailsResult[0];
        let PaxDetail = APIGetBookingDetailsResult.PaxDetail;

        let fromCityID = APIGetBookingDetailsResult.FromCityID;
        let fromCityName = APIGetBookingDetailsResult.FromCityName;
        let toCityID = APIGetBookingDetailsResult.ToCityID;
        let toCityName = APIGetBookingDetailsResult.ToCityName;
        let rsid = APIGetBookingDetailsResult.RouteCode;
        let journeyDate = APIGetBookingDetailsResult.JourneyDate;
        let mode = 'oneway';

        if (editPolicyDetails.buses.length === 0) {
            let searchurl = '/api/resource/searchRoutes?fromCityID=' + fromCityID + '&toCityID=' + toCityID + '&fromCityName=' + fromCityName + '&toCityName=' + toCityName + '&journeyDate=' + journeyDate + '&mode=' + mode;

            //for app webview pass app agentId in api
            const appAgentId = localStorage.getItem("AgentId");
            if(appAgentId){
                searchurl+='&appAgentId='+appAgentId;
            }

            fetchGet(searchurl).then(function (data) {
                store.dispatch(getSearchResults(data.filter(function (a) { return rsid === a.RouteScheduleId })[0]));
            }).catch(function (error) {
                store.dispatch(getSearchResults(false));
                console.log(error);
            });
        }

        if (this.props.editPolicy.seatChart.length === 0) {

            let seatcharturl = '/api/resource/seatArrangement?routeID=' + rsid + '&journeyDate=' + journeyDate;

            //for app webview pass app agentId in api
            const appAgentId = localStorage.getItem("AgentId");
            if(appAgentId){
                seatcharturl+='&appAgentId='+appAgentId;
            }

            fetchGet(seatcharturl).then(function (data) {
                store.dispatch(getSeatChartResults(data));
            }).catch(function (error) {
                console.log(error);
            });

            let selSeats = this.state.selSeats;

            PaxDetail.forEach(el => {
                selSeats.push(el.SeatNo);
            })
            this.setState({ selSeats });
        }
    }

    checkEditPrePostBooking = (e, i) => {
        const editPrePostBooking = this.state.editPrePostBooking === 'on' ? 'off' : 'on';
        this.setState({ editPrePostBooking })
    }

    checkEditSeatNo = (e, i) => {
        const editSeatNo = this.state.editSeatNo === 'on' ? 'off' : 'on';
        this.setState({ editSeatNo })
    }

    checkEditPickUp = (e, i) => {
        const editPickUp = this.state.editPickUp === 'on' ? 'off' : 'on';
        this.setState({ editPickUp })
    }

    checkEditDropOff = (e, i) => {
        const editDropOff = this.state.editDropOff === 'on' ? 'off' : 'on';
        this.setState({ editDropOff })
    }

    checkEditPassDetails = (e, i) => {
        const editPassDetails = this.state.editPassDetails === 'on' ? 'off' : 'on';
        this.setState({ editPassDetails })
    }

    checkEditComDetails = (e, i) => {
        const editComDetails = this.state.editComDetails === 'on' ? 'off' : 'on';
        this.setState({ editComDetails })
    }

    generateWrapperStyle = () => {
        const height = ((this.state.editPrePostBooking === "on") || (this.state.editSeatNo === "on") || (this.state.editPickUp === "on") || (this.state.editDropOff === "on") || (this.state.editPassDetails === "on") || (this.state.editComDetails === "on")) ? 'calc(100% - 75px)' : 'calc(100% - 40px)';
        return {
            padding: '0 15px',
            height: height
        }
    }

    closeSlider = (name, value) => {
        this.setState({ [name]: value });
    }
    checkEditOption = () => {
        const editOptionInitialState = [
            { name: 'search', value: this.state.editPrePostBooking },
            { name: 'seatChart', value: this.state.editSeatNo },
            { name: 'pickUp', value: this.state.editPickUp },
            { name: 'dropOff', value: this.state.editDropOff },
            { name: 'passDetails', value: this.state.editPassDetails },
            { name: 'comDetails', value: this.state.editComDetails }
        ]
        store.dispatch(getEditPolicyOptions(editOptionInitialState));

        for (var i = 0; i < editOptionInitialState.length; i++) {
            let el = editOptionInitialState[i];
            if (el.value === 'on') {
                this.setState({ [el.name]: true });
                break;
            }
        }
    }

    modificationpolicy = () => {
        const mpolicy = this.props.editPolicy.prepostfilter;
        if (this.state.editPrePostBooking == 'on') {
            var data = []
            if (mpolicy.ModificationPolicy.length > 0) {
                var policy = mpolicy.ModificationPolicy;

                for (let index = 0; index < policy.length; index++) {
                    let dt = policy[index];
                    if (index === policy.length - 1) {
                        data.push({ ...dt, label: "Before " + (policy[index].Min / 60).toFixed(1) + " hrs" });
                    } else if (index === 0) {
                        data.push({ ...dt, label: "0 to " + (policy[index + 1].Min / 60).toFixed(1) + " hrs" });
                    } else {
                        data.push({ ...dt, label: (policy[index].Min / 60).toFixed(1) + " to " + (policy[index + 1].Min / 60).toFixed(1) + " hrs" });
                    }
                }
            }

            return (
                <div id="policyView">
                    <div className="title">Modification Policy</div>
                    <div className="policy-data-wrapper">
                        <div className="head">Prepone</div>
                        <div className="p-item ">
                            <div>Modification Time</div>
                            <div>Modification Charges</div>
                        </div>
                        {
                            data.map((el, index) => {
                                return (
                                    <div className="p-item ">
                                        <div>{el.label}</div>
                                        <div>{(el.PreponePer ? el.PreponePer + "%" : "₹" + el.PreponeAmount)}</div>
                                    </div>
                                )
                            })
                        }
                        <div className="head">Postpone</div>
                        <div className="p-item ">
                            <div>Modification Time</div>
                            <div>Modification Charges</div>
                        </div>
                        {
                            data.map((el, index) => {
                                return (
                                    <div className="p-item ">
                                        <div>{el.label}</div>
                                        <div>{(el.PostponePer ? el.PostponePer + "%" : "₹" + el.PostponeAmount)}</div>
                                    </div>
                                )
                            })
                        }
                        <div className="head">Same Day Changes</div>
                        <div className="p-item ">
                            <div>Modification Time</div>
                            <div>Modification Charges</div>
                        </div>
                        {
                            data.map((el, index) => {
                                return (
                                    <div className="p-item ">
                                        <div>{el.label}</div>
                                        <div>{(el.SameDayPer ? el.SameDayPer + "%" : "₹" + el.SameDayAmount)}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            )
        }
    }

    editDetails = () => {
        if (this.props.editPolicy.data.APIGetBookingDetailsResult !== undefined) {
            let prepostfilter = this.props.editPolicy.prepostfilter && this.props.editPolicy.prepostfilter;
            let filter = this.props.editPolicy.filter;
            let pnrDetails = this.props.editPolicy.data.APIGetBookingDetailsResult[0];
            let loop = pnrDetails.PaxDetail;
            return (
                <div>
                    <div className='top-wrapper' style={{ background: window.color['searchBoxBgColor'] }}>
                        <span className='back-arrow' onClick={() => this.props.closeSlider('validateOTP', false)} >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='25px' fill='#fff'>
                                <path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z" />
                            </svg>
                        </span>
                        <span className='header-title'>
                            Edit Booking
                        </span>
                    </div>
                    <div className='ep-wrapper' style={{ zIndex: '4', padding: '15px', background: '#eeeeee' }}>
                        <h4 style={{ height: '40px', boxSizing: 'border-box' }}>Choose the section to edit</h4>
                        <div className='pnr-wrapper' style={this.generateWrapperStyle()}>
                            {/* 
                                (this.state.editSeatNo === 'off' && this.state.editPickUp === 'off' && this.state.editDropOff === 'off' && this.state.editPassDetails === 'off' && this.state.editComDetails === 'off') && prepostfilter && Object.keys(prepostfilter).length > 0 &&
                                <div className='editCheckbox-wrapper'>
                                    <Check
                                        value={this.state.editPrePostBooking}
                                        checked={this.state.editPrePostBooking === 'on'}
                                        handleChange={this.checkEditPrePostBooking}
                                        style={{ padding: '7px 5px' }}
                                        name='editPrePostBooking'
                                    />
                                    <span className='editLabelName'>
                                        Prepone/Postpone/Sameday Booking
                                    </span>
                                    <div>{this.modificationpolicy()}</div>
                                </div>
                             */}
                            {
                                this.state.editPrePostBooking === 'off' && filter.IsSeatNoEdit &&
                                <div className='editCheckbox-wrapper'>
                                    <Check
                                        value={this.state.editSeatNo}
                                        checked={this.state.editSeatNo === 'on'}
                                        handleChange={this.checkEditSeatNo}
                                        style={{ padding: '7px 5px' }}
                                        name='editSeatNo'
                                    />
                                    <span className='editLabelName'>
                                        Seat No
                                        <p>{pnrDetails.SeatNos}</p>
                                    </span>
                                </div>
                            }
                            {
                                this.state.editPrePostBooking === 'off' && filter.IsPickupEdit &&
                                <div className='editCheckbox-wrapper'>
                                    <Check
                                        value={this.state.editPickUp}
                                        checked={this.state.editPickUp === 'on'}
                                        handleChange={this.checkEditPickUp}
                                        style={{ padding: '7px 5px' }}
                                        name='editPickUp'
                                    />
                                    <span className='editLabelName'>
                                        Pickup Location
                                        <p>{pnrDetails.PickupName}</p>
                                    </span>
                                </div>
                            }
                            {
                                this.state.editPrePostBooking === 'off' && filter.IsDropOffEdit &&
                                <div className='editCheckbox-wrapper'>
                                    <Check
                                        value={this.state.editDropOff}
                                        checked={this.state.editDropOff === 'on'}
                                        handleChange={this.checkEditDropOff}
                                        style={{ padding: '7px 5px' }}
                                        name='editDropOff'
                                    />
                                    <span className='editLabelName'>
                                        Dropp-off Location
                                        <p>{pnrDetails.DropoffName}</p>
                                    </span>
                                </div>
                            }
                            {
                                this.state.editPrePostBooking === 'off' && (filter.IsPaxEmailEdit || filter.IsPaxGenderEdit || filter.IsPaxAgeEdit) &&
                                <div className='editCheckbox-wrapper'>
                                    <Check
                                        value={this.state.editPassDetails}
                                        checked={this.state.editPassDetails === 'on'}
                                        handleChange={this.checkEditPassDetails}
                                        style={{ padding: '7px 5px' }}
                                        name='editPassDetails'
                                    />
                                    <span className='editLabelName'>
                                        Passenger Details
                                        {/*<div>(
                                        {   filter.IsPaxEmailEdit   ? 'Email,' : ''  }
                                        {   filter.IsPaxGenderEdit  ? 'Gender,' : '' }
                                        {   filter.IsPaxAgeEdit     ? 'Age' : ''    }
                                        )</div>*/}
                                        <div>
                                            {loop.map((el, index) => {
                                                return (
                                                    <div key={index} style={{ display: 'flex' }}>
                                                        <span className='paxName'>{el.PaxName}</span>
                                                        <span className='paxAge'>{el.Age}</span>
                                                        <span className='paxGender'>{el.Gender}</span>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </span>
                                </div>
                            }
                            {
                                this.state.editPrePostBooking === 'off' && (filter.IsPaxNameEdit || filter.IsPaxPhoneEdit) &&
                                <div className='editCheckbox-wrapper'>
                                    <Check
                                        value={this.state.editComDetails}
                                        checked={this.state.editComDetails === 'on'}
                                        handleChange={this.checkEditComDetails}
                                        style={{ padding: '7px 5px' }}
                                        name='editComDetails'
                                    />
                                    <span className='editLabelName'>
                                        Communication Details
                                        {/*<div>(
                                        {   filter.IsPaxNameEdit   ? 'Name,' : ''  }
                                        {   filter.IsPaxPhoneEdit  ? 'Phone' : '' }
                                        )</div>*/}
                                        <div>
                                            <p>Name : {pnrDetails.PassengerName}</p>
                                            <p>Phone: {pnrDetails.PassengerContactNo1}</p>
                                            <p>Email: {pnrDetails.PassengerEmail}</p>
                                        </div>
                                    </span>
                                </div>
                            }
                        </div>
                        {((this.state.editPrePostBooking === "on") || (this.state.editSeatNo === "on") || (this.state.editPickUp === "on") || (this.state.editDropOff === "on") || (this.state.editPassDetails === "on") || (this.state.editComDetails === "on")) && <div className='btn' style={{ position: 'fixed', left: '0', bottom: '0', background: window.color['buttonColor'] }} onClick={() => this.checkEditOption()}>PROCEED</div>}
                    </div>
                </div>
            )
        }
    }
    cancel = () => {
        window.location.href = "/edit_policy"
    }

    getSubmitButton = () => {
        return (
            <div className='finalButton-wrapper'>
                <div className='cancel' style={{ background: '#fff' }} onClick={this.cancel}>
                    CANCEL
                </div>
                <div className='save' style={{ background: window.color['buttonColor'] }} onClick={this.isGenderCheck} >
                    SAVE
                </div>
            </div>
        );
    }

    isGenderCheck = () => {
        let isGenderCheck = 0;
        const seats = this.props.editPolicy.seatChart.APIGetChartMicrositeResult.Seats;
        let selectedSeats = this.props.editPolicy.editDetails.seatNo ? this.props.editPolicy.editDetails.seatNo : this.state.selSeats;

        seats.forEach(el => {
            if (selectedSeats.indexOf(el.SeatLabel) >= 0) {
                isGenderCheck = el.HasDoubleSeaterFemaleValidation || el.HasDoubleSlpFemaleValidation || el.HasFemaleValidation ? 1 : isGenderCheck;
            }
        })
        isGenderCheck === 1 ? this.genderValidation() : this.saveOrder();
    }

    genderValidation = () => {
        let counter = 1;
        const routeCode = this.props.editPolicy.buses.RouteScheduleId;
        const loop = this.props.editPolicy.editDetails.PaxDetail ? this.props.editPolicy.editDetails.PaxDetail : this.props.editPolicy.data.APIGetBookingDetailsResult[0].PaxDetail;

        let url = '/api/resource/APIGenderValidate?RouteCode=' + routeCode;
        Object.keys(loop).forEach(el => {
            url += ('&SeatLabel_' + counter + '=' + loop[el].SeatNo + '&Gender_' + counter + '=' + (loop[el].Gender === 'M' ? 'M' : 'F'));
            counter++;
        })

        let that = this;
        fetchGet(url).then(function (data) {
            const response = JSON.parse(data).APIBooking_GenderValidationResult;
            if (response.Status) {
                that.saveOrder();
            } else {
                alert(response.ErrorMessage);
                window.location.href = "/edit_policy";
            }
        }).catch(function (error) {
            alert(error);
        });
    }

    saveOrder = () => {
        let editPolicyDetails = this.props.editPolicy;
        let bus = editPolicyDetails.buses;
        let APIGetBookingDetailsResult = editPolicyDetails.data.APIGetBookingDetailsResult[0];

        let pick = editPolicyDetails.editDetails.pickup && editPolicyDetails.editDetails.pickup;
        let drop = editPolicyDetails.editDetails.dropoff && editPolicyDetails.editDetails.dropoff;
        let email = editPolicyDetails.editDetails.PaxEmail;
        let mobile = editPolicyDetails.editDetails.PaxMobile;
        let oldSeatDetails = editPolicyDetails.oldSeats;

        let postData = {
            mode: 'oneway',
            fromCityName: APIGetBookingDetailsResult.FromCityName,
            toCityName: APIGetBookingDetailsResult.ToCityName,
            routeCode: bus.RouteScheduleId,
            BusType: bus.BusType,
            companyId: bus.CompanyId,
            companyName: bus.CompanyName,
            journeyDate: bus.JourneyDate,
            fromCityId: bus.FromCityID,
            toCityId: bus.ToCityID,
            opHasDiscountPolicy: bus.HasDiscountPolicy,
            opDiscountAmt: bus.DiscountAmt,
            opDiscountPer: bus.DiscountPer,
            isNonRefundable: bus.IsNonRefundable,
            amenities: bus.AmenitiesType,
            pickUpID: pick ? pick.PickupID : APIGetBookingDetailsResult.PickupID,
            pickUpName: pick ? pick.PickupName : APIGetBookingDetailsResult.PickupName,
            pickUpTime: pick ? pick.PickupTime : APIGetBookingDetailsResult.DepartureTime,
            pickUpAddress: pick ? pick.Address : APIGetBookingDetailsResult.PickupAddress,
            pickUpLandmark: pick ? pick.Landmark : APIGetBookingDetailsResult.PickupLandmark,
            pickUpPhone: pick ? pick.ContactNumbers : APIGetBookingDetailsResult.PickupContactNo,
            dropOffID: drop ? drop.DropoffID : APIGetBookingDetailsResult.DropoffID,
            dropOffName: drop ? drop.DropoffName : APIGetBookingDetailsResult.DropoffName,
            dropOffTime: drop ? drop.DropoffTime : APIGetBookingDetailsResult.ArrivalTime,
            email: email ? email : APIGetBookingDetailsResult.PassengerEmail,
            mobile: mobile ? mobile : APIGetBookingDetailsResult.PassengerContactNo1,
            pnrno: APIGetBookingDetailsResult.PNRNo
        };

        if (editPolicyDetails.editDetails.seatNo) {
            const seats = editPolicyDetails.seatChart.APIGetChartMicrositeResult.Seats;
            let selectedSeats = editPolicyDetails.editDetails.seatNo;
            let index = 0;
            seats.forEach(el => {
                if (selectedSeats.indexOf(el.SeatLabel) >= 0) {
                    postData['seats[' + index + ']'] = el.SeatLabel;
                    postData['isSleeper[' + index + ']'] = el.Width === 2 || el.Height === 2 ? true : false;
                    postData['isAC[' + index + ']'] = el.IsAC;
                    postData['hasSTax[' + index + ']'] = el.HasSTax;
                    postData['serviceTax[' + index + ']'] = el.ServiceTax;
                    postData['hasSCharge[' + index + ']'] = el.HasSCharge;
                    postData['serviceCharge[' + index + ']'] = el.ServiceCharge;
                    postData['price[' + index + ']'] = el.Fare - (el.HasSCharge ? parseInt(el.ServiceCharge, 10) : 0) - (el.HasSTax ? parseInt(el.ServiceTax, 10) : 0);
                    index++;
                }
            })

            let i = 0;
            let PaxDetail = editPolicyDetails.editDetails.PaxDetail;
            PaxDetail.forEach(el => {
                if (selectedSeats.indexOf(el.SeatNo) >= 0) {
                    postData['name[' + i + ']'] = el.PaxName;
                    postData['age[' + i + ']'] = el.Age;
                    postData['gender[' + i + ']'] = el.Gender;
                    i++;
                }
            })
        } else {
            let index = 0;
            APIGetBookingDetailsResult.PaxDetail.forEach(el => {
                postData['seats[' + index + ']'] = el.SeatNo;
                postData['gender[' + index + ']'] = el.Gender;
                postData['name[' + index + ']'] = el.PaxName;
                postData['age[' + index + ']'] = el.Age;
                postData['hasSTax[' + index + ']'] = el.Tax > 0 ? 1 : 0;
                postData['serviceTax[' + index + ']'] = el.Tax;
                //postData['isSleeper[' + index + ']'] = el.Width === 2 || el.Height === 2 ? true : false;
                //postData['isAC[' + index + ']'] = el.IsAC;
                //postData['hasSCharge[' + index + ']'] = el.HasSCharge;
                //postData['serviceCharge[' + index + ']'] = el.ServiceCharge;
                //postData['price[' + index + ']'] = el.Fare - (el.HasSCharge ? parseInt(el.ServiceCharge, 10) : 0)- (el.HasSTax ? parseInt(el.ServiceTax, 10) : 0);
                index++;
            })
        }

        let k = 0;
        oldSeatDetails.forEach(el => {
            postData['oldSeat[' + k + ']'] = el.SeatNo;
            k++;
        })

        const urlBookingModify = '/api/resource/BookingModify';
        fetchPost(urlBookingModify, postData).then(data => {
            let bookingModify = JSON.parse(data).APIMicrosite_BookingsModifyResult;
            if (bookingModify.IsSuccess) {
                const url = '/api/expco/editordersave';
                let that = this;
                fetchPost(url, postData).then(data => {
                    if (data.success) {
                        that.setState({ editSuccess: true });
                    } else {
                        alert(data.error)
                    }
                })
                    .catch((err) => console.log(err));
            } else {
                alert(bookingModify.ErrorMessage)
            }
        })
            .catch((err) => console.log(err));
    }

    posttoreschedule = () => {
        document.getElementById('editform').submit();
    }

    render() {
        let editdetails = [];
        editdetails.push('reschedule');
        return (
            <div>
                <form id='editform' method='POST' action={'/ticket/editbooking/' + this.props.editPolicy.data.APIGetBookingDetailsResult[0].PNRNo}>
                    <input type='hidden' name='pnrno' value={this.props.editPolicy.data.APIGetBookingDetailsResult[0].PNRNo} />
                    <input type='hidden' name='otpcheck' value="true" />
                    <input type='hidden' name='editdetails' value={editdetails} />
                </form>
                {this.state.validateOTP && this.editDetails()}
                {this.state.search && this.posttoreschedule()}
                {this.state.seatChart && <Seatchart closeSlider={(a, b) => this.closeSlider(a, b)} />}
                {this.state.pickUp && <PickUp closeSlider={(a, b) => this.closeSlider(a, b)} />}
                {this.state.dropOff && <DropOff closeSlider={(a, b) => this.closeSlider(a, b)} />}
                {this.state.passDetails && <PassDetails closeSlider={(a, b) => this.closeSlider(a, b)} />}
                {this.state.comDetails && <ComDetails closeSlider={(a, b) => this.closeSlider(a, b)} />}
                {this.props.editPolicy.finalSave && this.getSubmitButton()}
                {this.state.editSuccess && <EditSuccess />}
            </div>
        );
    }
}

const mapStateToProps = function (store) {
    return (store);
};

export default connect(mapStateToProps)(withRouter(EditDetail));


// WEBPACK FOOTER //
// ./src/components/editDetail/EditDetail.js